import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { DocumentEditor } from "./DocumentEditor";
import { FileText, Edit2, Download, Loader2 } from "lucide-react";
import { useState, useEffect } from "react";
import { useDocxExport } from "@/hooks/useDocxExport";
interface DocumentPreviewDialogProps {
  isOpen: boolean;
  onClose: () => void;
  content: string | null;
  loading: boolean;
  onContentChange: (content: string) => void;
}
export const DocumentPreviewDialog = ({
  isOpen,
  onClose,
  content,
  loading,
  onContentChange
}: DocumentPreviewDialogProps) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedContent, setEditedContent] = useState(content || '');
  const {
    exportToDocx
  } = useDocxExport();
  useEffect(() => {
    setEditedContent(content || '');
  }, [content]);
  const handleExportDOCX = async () => {
    if (content) {
      await exportToDocx(content, `documento-${new Date().toISOString().slice(0, 10)}`);
    }
  };
  const handleSave = () => {
    onContentChange(editedContent);
    setIsEditing(false);
  };
  if (!isOpen) return null;
  return <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="w-[95vw] max-w-4xl h-[90vh] flex flex-col p-0 gap-0 rounded-xl">
        <DialogHeader className="px-4 py-2 md:p-6 border-b">
          <DialogTitle className="text-primary flex items-center gap-2">
            <FileText className="w-5 h-5" />
            {isEditing ? "Editar Documento" : "Visualizar Documento"}
          </DialogTitle>
        </DialogHeader>
        
        <div className="flex-1 overflow-auto p-4 md:p-6">
          {loading ? <div className="flex flex-col items-center justify-center h-full">
              <Loader2 className="h-8 w-8 animate-spin text-primary mb-4" />
              <p className="text-lg font-medium text-center">
                Gerando seu documento...
              </p>
              <p className="text-sm text-muted-foreground text-center mt-2">
                Isso pode levar alguns segundos.
              </p>
            </div> : isEditing ? <DocumentEditor content={editedContent} onSave={handleSave} onCancel={() => setIsEditing(false)} onChange={setEditedContent} /> : <div className="h-full flex flex-col">
              <div id="document-content" className="bg-white rounded-lg shadow-sm mx-auto p-8">
                <div className="prose max-w-none" dangerouslySetInnerHTML={{
              __html: content || ''
            }} />
              </div>
            </div>}
        </div>

        {!loading && !isEditing && <div className="border-t p-4 md:p-6 bg-white">
            <div className="flex flex-col sm:flex-row justify-end gap-2">
              
              <Button onClick={handleExportDOCX} className="w-full sm:w-auto bg-primary hover:bg-primary/90 text-white flex items-center justify-center gap-2">
                <Download className="w-4 h-4" />
                <span>Exportar DOCX</span>
              </Button>
              <Button onClick={onClose} variant="outline" className="w-full sm:w-auto">
                Fechar
              </Button>
            </div>
          </div>}
      </DialogContent>
    </Dialog>;
};